import React from 'react'

const categories = [
  'Fruits & Vegetables',
  'Meat & Fish',
  'Dairy',
  'Sweets & Farsan',
  'Bakery'
]

const shops = Array.from({ length: 6 })

export default function LocalitySkeleton (): JSX.Element {
  return (
    <div className="container mx-auto">
      <div className="min-h-screen bg-white px-4 py-3 md:px-6">
        {/* Breadcrumb */}
        <div className="mb-8 flex items-center gap-3">
          <Skeleton className="h-5 w-14" />
          <span className="text-gray-300">/</span>
          <Skeleton className="h-5 w-14" />
          <span className="text-gray-300">/</span>
          <Skeleton className="h-5 w-24" />
          <span className="text-gray-300">/</span>
          <Skeleton className="h-5 w-44" />
        </div>

        {/* Page Header */}
        <div className="mb-12">
          <Skeleton className="h-12 w-[620px] max-w-full rounded-md" />
          <Skeleton className="mt-4 h-6 w-[570px] max-w-full rounded-md" />
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[315px_1fr]">
          {/* Sidebar */}
          <aside className="rounded-[24px] border border-gray-200 p-6">
            <Skeleton className="mb-6 h-7 w-40" />

            <div className="space-y-4">
              {categories.map((category, index) => (
                <div
                  key={category}
                  className={`flex h-[124px] items-center gap-5 rounded-[18px] px-4 ${
                    index === 0 ? 'bg-pink-50' : ''
                  }`}
                >
                  {/* Category icon */}
                  <Skeleton className="h-[84px] w-[84px] shrink-0 rounded-[22px]" />

                  {/* Category name */}
                  <Skeleton
                    className={`h-6 ${
                      index === 0 ? 'w-36' : 'w-32'
                    }`}
                  />
                </div>
              ))}
            </div>
          </aside>

          {/* Shops */}
          <main>
            <div className="mb-7 flex items-center justify-between gap-4">
              <Skeleton className="h-9 w-80 max-w-[70%]" />
              <Skeleton className="h-5 w-28" />
            </div>

            <div className="grid grid-cols-1 gap-7 xl:grid-cols-2">
              {shops.map((_, index) => (
                <ShopCardSkeleton key={index} />
              ))}
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

/* ---------------------------------- */
/* Reusable Skeleton                   */
/* ---------------------------------- */

function Skeleton ({
  className = ''
}: {
  className?: string
}): JSX.Element {
  return (
    <div
      className={`animate-pulse bg-gray-200 ${className}`}
      aria-hidden="true"
    />
  )
}

/* ---------------------------------- */
/* Shop Card Skeleton                  */
/* ---------------------------------- */

function ShopCardSkeleton (): JSX.Element {
  return (
    <div className="flex min-h-[140px] items-center gap-6 rounded-[30px] border border-gray-200 p-6">
      {/* Image */}
      <Skeleton className="h-[80px] w-[152px] shrink-0 rounded-[26px]" />

      {/* Content */}
      <div className="min-w-0 flex-1">
        <Skeleton className="h-6 w-[85%] rounded-md" />
        <Skeleton className="mt-2 h-6 w-[65%] rounded-md" />

        <div className="mt-7 flex items-center gap-4">
          {/* Rating */}
          <Skeleton className="h-4 w-20 rounded-full" />

          {/* Delivery */}
          <Skeleton className="h-4 w-28 rounded-md" />
        </div>
      </div>
    </div>
  )
}
